import React from "react";
import Box from "@mui/material/Box";
import Fade from "react-reveal/Fade";
import { useTranslation } from "react-i18next";
const Testimonial1 = () => {
  const { t, i18n } = useTranslation();
  return (
    <Box
      sx={{
        width: 1,

        display: "flex",
        justifyContent: "center",
      }}
    >
      <Fade delay={400}>
        <Box>
          {t("Clean well")}
          <br />
          <Box className="normal" sx={{ fontSize: "14px", pt: 1 }}>
            <div
              dangerouslySetInnerHTML={{
                __html: t(
                  "I love these wipes They really clean anything and everything easily.<br />I recommend it."
                ),
              }}
            />
          </Box>
          <Box sx={{ fontSize: "14px", fontWeight: 100, pt: 1, color: "gray" }}>
            Re****** {t("Allen, TX")}
          </Box>
        </Box>
      </Fade>
    </Box>
  );
};

export default Testimonial1;
